import React from "react";

export function Worldle() {
  return (
    <span className="font-bold">
              <span style={{color:"#EB4040"}}>V</span>
              <span style={{color:"#E11926"}}>A</span>
              <span style={{color:"#347103"}}>L</span>
              <span style={{color:"#00853D"}}>G</span>
              <span style={{color:"#87ADD7"}}>L</span>
              <span style={{color:"#004F80"}}>E</span>
    </span>
  );
}
